import { render, staticRenderFns } from "./BankCodeList.vue?vue&type=template&id=058fc31b&scoped=true&lang=pug&"
import script from "./BankCodeList.vue?vue&type=script&lang=ts&"
export * from "./BankCodeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058fc31b",
  null
  
)

export default component.exports